import axiosInstance from "./axiosInstance";
import authAxiosInstance from "./authAxioInstance";

export const developerTollApi = {
    // get pdfeditor details

    getUsers: async () => {
      const response = await axiosInstance.get(
          `/developer-tool/fetch_all_users`,
          { authRequired: true }
      );
      return response.data;
    },

    addUser: async (payload) => {
      const response = await axiosInstance.post(
          `/developer-tool/add_user`,
          payload,
          { authRequired: true }
      );
      return response.data;
    },

    updateUser: async (payload) => {
      const response = await axiosInstance.post(
          `/developer-tool/update_user`,
          payload,
          { authRequired: true }
      );
      return response.data;
    },

    deleteUser: async (payload) => {
      const response = await axiosInstance.post(
          `/developer-tool/delete_user`,
          payload,
          { authRequired: true }
      );
      return response.data;
    },

    getAllProducts: async () => {
      const response = await axiosInstance.get(
          `/developer-tool/fetch_all_products`,
          { authRequired: true }
      );
      return response.data;
    },

    getCompanyCreditsInfo: async (companyId, templateId) => {
      const response = await axiosInstance.get(
          `/developer-tool/fetch_company_credits_info/${companyId}/${templateId}`,
          {
            authRequired: true,
            headers: {
              Accept: "application/json",
            },
          }
      );
      return response.data;
    },

    addProduct: async (payload) => {
      const response = await axiosInstance.post(
          `/developer-tool/add_product`,
          payload,
          { authRequired: true }
      );
      return response.data;
    },

    updateProduct: async (payload) => {
      const response = await axiosInstance.post(
          `/developer-tool/update_product`,
          payload,
          { authRequired: true }
      );
      return response.data;
    },

    deleteProduct: async (payload) => {
      const response = await axiosInstance.post(
          `/developer-tool/delete_product`,
          payload,
          { authRequired: true }
      );
      return response.data;
    },

    getAllTags: async (product_id) => {
      const response = await axiosInstance.get(
          `/developer-tool/fetch_product_tags/${product_id}`,
          { authRequired: true }
      );
      return response.data;
    },

    addTag: async (payload) => {
      const response = await axiosInstance.post(
          `/developer-tool/add_tag`,
          payload,
          { authRequired: true }
      );
      return response.data;
    },

    updateTag: async (payload) => {
      const response = await axiosInstance.post(
          `/developer-tool/update_tag`,
          payload,
          { authRequired: true }
      );
      return response.data;
    },

    deleteTag: async (payload) => {
      const response = await axiosInstance.post(
          `/developer-tool/delete_tag`,
          payload,
          { authRequired: true }
      );
      return response.data;
    },

    getAllTagEndpoint: async (tag_id) => {
      const response = await axiosInstance.get(
          `/developer-tool/fetch_tag_endpoints/${tag_id}`,
          { authRequired: true }
      );
      return response.data;
    },

    addEndpoint: async (formData) => {
      const response = await axiosInstance.post(
          `/developer-tool/add_endpoint`,
          formData,
          { authRequired: true,
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
          
      );
      return response.data;
    },

    updateEndpoint: async (formData) => {
      const response = await axiosInstance.post(
          `/developer-tool/update_endpoint`,
          formData,
          { authRequired: true,
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
      );
      return response.data;
    },

    deleteEndpoint: async (payload) => {
      const response = await axiosInstance.post(
          `/developer-tool/delete_endpoint`,
          payload,
          { authRequired: true }
      );
      return response.data;
    },


    // for uswr and pulic url without token

    getAllPublicProducts: async () => {
      const response = await axiosInstance.get(
          `/developer-tool/fetch_public_products`,
      );
      return response.data;
    },

    getAllPublicProductTags: async (product_id) => {
      const response = await axiosInstance.get(
          `/developer-tool/fetch_product_public_tags/${product_id}`,
      );
      return response.data;
    },

    getAllPublicTagsEndpoint: async (tag_id) => {
      const response = await axiosInstance.get(
          `/developer-tool/fetch_tag_public_endpoints/${tag_id}`,
      );
      return response.data;
    },


    visitAdminUrl: async (data, signature) => {
      const response = await authAxiosInstance.post(
          `/EsignServices/generate_sso_link_developer_tool`,
          data,
          {
            headers: {
              signature: signature
            }
          }
      );
      return response.data;
    },

   

    login: async (username) => {
        const response = await axiosInstance.post(
            `/EsignServices/get_pdf_editor_details`,
            { username }
        );
        return response.data;
    },

    sendOtpForgotPassword: async (email) => {
        const response = await axiosInstance.post(
            `/EsignServices/NewSendOtpForgetPassword`,
            { email }
        );
        return response.data;
    },

    updatePassword: async (body) => {
        const response = await axiosInstance.post(
            `/EsignServices/ChangePassword`,
            body
        );
        return response.data;
    },

    verifyOtp: async (email, otp) => {
        const response = await axiosInstance.post(
            `/EsignServices/NewVerifyOtpForgetPassword`,
            { email, otp }
        );
        return response.data;
    },

    setNewPassword: async (email, new_password, otp) => {
        const response = await axiosInstance.post(
            `/EsignServices/NewSetPasswordForgetPassword`,
            { email, new_password, otp }
        );
        return response.data;
    },

  };
  
